/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/*
$(function() {
  if ($(".size_cart-items").length > 0) {
    $('.product-form__popup-link').on('click', function(){
      $(".size_cart-items").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        prevArrow:'<div class="ap-slide-arrow ap-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"/></svg></div>',
        nextArrow:'<div class="ap-slide-arrow ap-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24" viewBox="0 0 24 24" width="24"><g><path d="M0,0h24v24H0V0z" fill="none"/></g><g><polygon points="6.23,20.23 8,22 18,12 8,2 6.23,3.77 14.46,12"/></g></svg></div>',
      });
    });    
  }
});

*/

if ($(".sz_tl_items").length > 0) {
  $(".sz_tl_items").slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    infinite: false,
    dots: false,
    prevArrow:'<div class="sz-carousel__nav sz__nav--prev slick-arrow"><span class="sz_icon sz_icon--prev"></span></div>',
    nextArrow:'<div class="sz-carousel__nav sz__nav--next slick-arrow"><span class="sz_icon sz_icon--next"></span></div>'
  });
}

if ($(".ap_text_slides").length > 0) {
  $(".ap_text_slides").slick({
    autoplay:true,
    autoplaySpeed:2000,    
    fade: true,
    cssEase: 'linear',    
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: true,
    prevArrow:'<div class="sz-carousel__nav sz__nav--prev slick-arrow"><span class="sz_icon sz_icon--prev"></span></div>',
    nextArrow:'<div class="sz-carousel__nav sz__nav--next slick-arrow"><span class="sz_icon sz_icon--next"></span></div>'
  });
}



$(window).on("load resize",function(e){
  if ($(".sz_tl_items").length > 0) {
    var highest = null;
    var top_highest = null;
    var bottom_highest = null;
    var gheight = null;
    var hi = 0;
    
    $(".sz_tl_item").find('.top_row').each(function(){
        var h_t = $(this).height();
        //alert(h_t);
        if(h_t > hi){
          top_highest = h_t;
          $(".sz_tl_row.bottom_row").css("position", "relative");
          $(".sz_tl_item .top_row").css("min-height", top_highest);
        }    
    });
    
    
    $(".sz_tl_item").find('.bottom_row').each(function(){
      var h_b = $(this).height();
      //alert(h_b);
      if(h_b > hi){
        bottom_highest = h_b;
        $(".sz_tl_item .bottom_row").css("min-height", bottom_highest );
      }    
    });
    
    
      
      //alert(top_highest);
      //alert(bottom_highest);
      if ($(".sz_tl_items").length > 0) {
        var gheight = parseInt(top_highest) + parseInt(bottom_highest);
        $(".sz_tl_item").css("min-height", gheight);          
        $(".sz_tl_row.bottom_row").css("top", parseInt(top_highest) + 40);    
        $(".sz_timeline_wrap .nv , .sz-carousel__nav").css("top", parseInt(top_highest) + 40);    
        $(".sz_tl_item.sz_tl_item_top .nv-in").css("top", top_highest);
        $(".sz_tl_item.sz_tl_item_bottom .nv-in").css("top", parseInt(top_highest) + 73);           
      }
    
  }
}).resize();          


$(document).on('click', '.custm-video_trigger', function(e) {
  var v_id  = $(this).data('v_id');
  $('#' + v_id + ' video.video_cutm').trigger('play');
});

